module.exports = __webpack_public_path__ + "static/img/6.703e66e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingka3/6.jpg
// module id = 6RPH
// module chunks = 16